import { getAllPrinterSettings } from '../api/printerSettings';

const ZEBRA_VENDOR_ID = 0x0a5f;

export const PRINTER_TASKS = {
  voucherQr: { key: 'voucher-qr', label: 'Voucher QR codes' },
  voucherEnvelope: { key: 'voucher-envelope', label: 'Voucher envelope / box label' },
  voucherPackage: { key: 'voucher-package', label: 'Voucher package label' },
  deliverySticker: { key: 'delivery-sticker', label: 'Delivery sticker' },
  deliveryQr: { key: 'delivery-qr', label: 'QR codes' },
  deliveryLabels: { key: 'delivery-labels', label: 'Print name labels' },
  deliveryPackage: { key: 'delivery-package', label: 'Delivery package label' },
};

const describeDevice = (device) => ({
  vendorId: device.vendorId,
  productId: device.productId,
  serialNumber: device.serialNumber || null,
  productName: device.productName || 'Zebra printer',
});

const devicesMatch = (device, saved) =>
  device.vendorId === saved.vendorId &&
  device.productId === saved.productId &&
  (!saved.serialNumber || device.serialNumber === saved.serialNumber);

const openAndClaim = async (device) => {
  await device.open();
  if (device.configuration === null) {
    await device.selectConfiguration(1);
  }
  await device.claimInterface(0);
  return device;
};

export const pickPrinterDevice = async () => {
  const device = await navigator.usb.requestDevice({
    filters: [{ vendorId: ZEBRA_VENDOR_ID }],
  });

  await openAndClaim(device);
  try {
    await device.releaseInterface(0);
  } catch (e) {}
  try {
    await device.close();
  } catch (e) {}

  return describeDevice(device);
};

export const connectPrinterForTask = async (taskKey, token) => {
  let saved = null;
  try {
    const allSettings = await getAllPrinterSettings(token);
    saved = (allSettings || []).find((setting) => setting.taskKey === taskKey) || null;
  } catch (error) {
    saved = null;
  }

  if (saved) {
    const authorizedDevices = await navigator.usb.getDevices();
    const match = authorizedDevices.find((device) => devicesMatch(device, saved));
    if (match) {
      return openAndClaim(match);
    }
  }

  const device = await navigator.usb.requestDevice({
    filters: [{ vendorId: ZEBRA_VENDOR_ID }],
  });
  return openAndClaim(device);
};
